export default ({id, itApplicationName, itApplicationTypeId, itApplicationTypeID, knowledgeITApplicationId}) => ({
	id,
	name: itApplicationName,
	type: itApplicationTypeId ?? itApplicationTypeID,
	knowledgeITApplicationId
});
